import Account from "../../component/profile/Account";

function ProfileAccount() {
  return (
    <div className="page-body">
      <Account />
    </div>
  );
}

export default ProfileAccount;
